import { merge } from 'lodash';
import type { Payload } from './types';
import type { ModuleName } from '.';
import { moduleMap } from '.';

export const toPayload = (
  templateId: string,
  data: Partial<Record<ModuleName, unknown>>
): Payload => {
  const parts = Object.entries(data).map(([moduleName, formData]) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return moduleMap[moduleName as ModuleName].transformer.toPayload(formData as any);
  });

  // Sort parts to make sure purchase module has priority over other modules with dataSourceType when merging
  parts.sort((a, b) => {
    const aDataSourceType = a.lottery?.dataSource?.dataSourceType;
    const bDataSourceType = b.lottery?.dataSource?.dataSourceType;

    if (aDataSourceType === 'PURCHASE') return 1;
    if (bDataSourceType === 'PURCHASE') return -1;

    return 0;
  });

  // No typechecking here
  const lotteryData = merge(
    {
      lottery: {
        lotteryTemplateId: templateId,
        modules: Object.keys(data),
      },
      translation: {},
    },
    ...parts
  );

  // Filter out empty constraints to avoid sending them to the backend
  if (lotteryData.lottery?.drawConstraints) {
    lotteryData.lottery.drawConstraints = lotteryData.lottery.drawConstraints.filter(
      (constraint: Record<string, unknown>) => Object.keys(constraint).length > 0
    );
  }

  return lotteryData;
};

export const fromPayload = (
  payload: Payload,
  modules: Array<ModuleName>
): Record<string /* ModuleName */, unknown> => {
  const data = Object.fromEntries(
    modules.map((moduleName) => {
      try {
        const { transformer } = moduleMap[moduleName];
        return [moduleName, transformer.fromPayload(payload)];
      } catch (err) {
        // eslint-disable-next-line no-console
        console.warn(err);
      }
      return [moduleName, {}];
    })
  );
  return data;
};
